import { ITennisTourRanking } from "@sky-it-livedata/livedata-sports-design-system";
import { RankingSubscriptionData } from "../types";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { UpdateRankingWidgetInputSchema } from "cdk/graphql";
import { isValidRankingSubscription } from "./typeguards";

export const transformSubscription = (obj: RankingSubscriptionData): ITennisTourRanking => {
  if (isValidRankingSubscription(obj)) {
      UpdateRankingWidgetInputSchema().parse(obj.data.onUpdateRankingWidgetByTourId, {reportInput: true});
      const { rankings } = obj?.data?.onUpdateRankingWidgetByTourId!;

      return {
        ranking: rankings?.map((item) => {
          return {
            position: item?.rank,
            flagUrl: item?.nationality,
            name: item?.playerName,
            score: Number(item?.points),
            trend: Number(item?.trend),
            id: item?.rank?.toString(),
      }}),
      } as ITennisTourRanking;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in RankingSubscription object',
      data: obj
    });
  }
};

